module.exports = __webpack_public_path__ + "img/spruce-winter.b2621eda.png";